import { render } from "./ReportConfirm.vue?vue&type=template&id=0d988b36"
import script from "./ReportConfirm.vue?vue&type=script&lang=js"
export * from "./ReportConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__